import { useMutation } from "@tanstack/react-query";
import { panelDelete } from "common/api/sakusas/sakusas_panel";
import { useInvalidateQueryByKeys } from "hooks/query_common/useInvalidateQueryByKeys";

type UseSakusasPanelDeleteParams = {
  invalidateKeys?: string[];
};

export const useSakusasPanelDelete = (
  hookParams?: UseSakusasPanelDeleteParams
) => {
  const { invalidateQueriesByKeys } = useInvalidateQueryByKeys();
  const { mutate: panelDeleteMutate } = useMutation({
    mutationFn: async (id: string) => await panelDelete(id),
    onSuccess: () => {
      if (hookParams?.invalidateKeys) {
        invalidateQueriesByKeys(hookParams.invalidateKeys);
      }
    },
  });

  return { panelDeleteMutate };
};
